<div
  class="bg-elevated border-default flex max-h-full flex-col overflow-hidden rounded-md border shadow-md"
  role="dialog"
  [attr.aria-label]="title()">
  <div class="border-weak flex items-start gap-2 border-b px-3 py-2">
    <span class="min-w-0 flex-1 text-xs font-semibold">{{ title() }}</span>
    <button
      type="button"
      class="text-text-tertiary hover:text-text-primary flex h-5 w-5 shrink-0 items-center justify-center rounded transition-colors"
      [title]="'common.close' | translate"
      [attr.aria-label]="'common.close' | translate"
      (click)="dismiss.emit()">
      <i [class]="ICONS.x" class="text-xs"></i>
    </button>
  </div>

  <ul class="min-h-0 flex-1 overflow-y-auto py-1">
    @for (row of rows(); track $index) {
      <li data-testid="kpi-detail-row" class="flex items-baseline gap-3 px-3 py-1 text-xs">
        <span class="text-text-secondary min-w-0 flex-1 break-words">{{ row.key }}</span>
        @if (row.text) {
          <span class="text-text-primary shrink-0 font-semibold tabular-nums">{{
            row.text
          }}</span>
        }
      </li>
    }
  </ul>
</div>
